export const NewTab = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_2348_3382)">
        <path
          d="M7.5 0C7.08516 0 6.75 0.335156 6.75 0.75C6.75 1.16484 7.08516 1.5 7.5 1.5H9.43828L4.72031 6.22031C4.42734 6.51328 4.42734 6.98906 4.72031 7.28203C5.01328 7.575 5.48906 7.575 5.78203 7.28203L10.5 2.56172V4.5C10.5 4.91484 10.8352 5.25 11.25 5.25C11.6648 5.25 12 4.91484 12 4.5V0.75C12 0.335156 11.6648 0 11.25 0H7.5ZM1.875 0.75C0.839062 0.75 0 1.58906 0 2.625V10.125C0 11.1609 0.839062 12 1.875 12H9.375C10.4109 12 11.25 11.1609 11.25 10.125V7.5C11.25 7.08516 10.9148 6.75 10.5 6.75C10.0852 6.75 9.75 7.08516 9.75 7.5V10.125C9.75 10.3313 9.58125 10.5 9.375 10.5H1.875C1.66875 10.5 1.5 10.3313 1.5 10.125V2.625C1.5 2.41875 1.66875 2.25 1.875 2.25H4.5C4.91484 2.25 5.25 1.91484 5.25 1.5C5.25 1.08516 4.91484 0.75 4.5 0.75H1.875Z"
          fill="#94A3B8"
        />
      </g>
      <defs>
        <clipPath id="clip0_2348_3382">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DropDownOptions = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="3"
      height="12"
      viewBox="0 0 3 12"
      fill="none"
    >
      <g clipPath="url(#clip0_2351_3908)">
        <path
          d="M1.5 8.4375C1.1519 8.4375 0.818064 8.57578 0.571922 8.82192C0.325781 9.06806 0.1875 9.4019 0.1875 9.75C0.1875 10.0981 0.325781 10.4319 0.571922 10.6781C0.818064 10.9242 1.1519 11.0625 1.5 11.0625C1.8481 11.0625 2.18194 10.9242 2.42808 10.6781C2.67422 10.4319 2.8125 10.0981 2.8125 9.75C2.8125 9.4019 2.67422 9.06806 2.42808 8.82192C2.18194 8.57578 1.8481 8.4375 1.5 8.4375ZM1.5 4.6875C1.1519 4.6875 0.818064 4.82578 0.571922 5.07192C0.325781 5.31806 0.1875 5.6519 0.1875 6C0.1875 6.3481 0.325781 6.68194 0.571922 6.92808C0.818064 7.17422 1.1519 7.3125 1.5 7.3125C1.8481 7.3125 2.18194 7.17422 2.42808 6.92808C2.67422 6.68194 2.8125 6.3481 2.8125 6C2.8125 5.6519 2.67422 5.31806 2.42808 5.07192C2.18194 4.82578 1.8481 4.6875 1.5 4.6875ZM2.8125 2.25C2.8125 1.9019 2.67422 1.56806 2.42808 1.32192C2.18194 1.07578 1.8481 0.9375 1.5 0.9375C1.1519 0.9375 0.818064 1.07578 0.571922 1.32192C0.325781 1.56806 0.1875 1.9019 0.1875 2.25C0.1875 2.5981 0.325781 2.93194 0.571922 3.17808C0.818064 3.42422 1.1519 3.5625 1.5 3.5625C1.8481 3.5625 2.18194 3.42422 2.42808 3.17808C2.67422 2.93194 2.8125 2.5981 2.8125 2.25Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2351_3908">
          <rect width="3" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
